import { ButtonOutlineProps } from "./types"
import React from "react"
import { ButtonCore } from "./core"

const ButtonOutline: React.FC<ButtonOutlineProps> = (props) => {
  return <ButtonCore {...props} type="outline"></ButtonCore>
}

export default ButtonOutline
